function teams() {
  let teamsControlButtons = document.querySelectorAll('.teams__control-button');
  let teamsItems = document.querySelectorAll('.teams__item');

  if (teamsControlButtons.length) {
    teamsControlButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => {
        teamsItems.forEach((team, j) => {
          if (j === i) {
            team.classList.add('is-active')
          } else {
            team.classList.remove('is-active')
          }
        })

        teamsControlButtons.forEach((otherBtn, k) => {
          if (k === i) {
            otherBtn.classList.add('is-active')
          } else {
            otherBtn.classList.remove('is-active')
          }
        })
      })
    })
  }


  // 
  let headerLink = document.querySelector('.header__link');

  headerLink.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('#teams').scrollIntoView({
        behavior: "smooth",
        block: "start"
    });
  })
}

export { teams }